import { useMemo, useState } from 'react';
import { compileFormula, FormulaSyntaxError } from '@workspace/formulas';

interface FormulaEditorProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export function FormulaEditor({ value, onChange, disabled }: FormulaEditorProps) {
  const [touched, setTouched] = useState(false);

  const validation = useMemo(() => {
    const trimmed = value.trim();
    if (!trimmed) {
      return { valid: true, message: 'Carga manual (sin fórmula)' };
    }
    try {
      compileFormula(trimmed);
      return { valid: true, message: 'Fórmula válida' };
    } catch (error) {
      const msg = error instanceof FormulaSyntaxError ? error.message : 'Sintaxis inválida';
      return { valid: false, message: msg };
    }
  }, [value]);

  return (
    <div className="space-y-1">
      <label className="text-sm font-medium" htmlFor="indicator-formula">
        Fórmula (opcional)
      </label>
      <textarea
        id="indicator-formula"
        className="w-full min-h-[80px] rounded-md border border-border bg-background px-3 py-2 text-sm font-mono"
        value={value}
        disabled={disabled}
        placeholder="Ej: 100 - defectos / total * 100"
        onChange={(e) => {
          setTouched(true);
          onChange(e.target.value);
        }}
        onBlur={() => setTouched(true)}
      />
      {(touched || value.trim()) && (
        <p className={`text-xs ${validation.valid ? 'text-green-700' : 'text-destructive'}`}>
          {validation.message}
        </p>
      )}
    </div>
  );
}
